import { UiCommand, UiCommandEvent } from '@ui/cer-ui-types';
import { CerUiIcons } from '@ui/cer-ui-icons';

import { BankPaymentJournalClient } from 'src/app/api';
import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView, ICerViewComponent } from '@cer/cer-form/cer-form-view';

const uiCmdPaymentFileCreate: UiCommand = { id: 'CreatePaymentFile', text: "Hent betalingsfil", iconCss: CerUiIcons.import };

export class BankPaymentJournalVendorForm extends CerFormAdapter {

  override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'bank-betalingskladde', dataApiName: 'BankPaymentJournalVendor', text: "Betalingskladde",
        primaryKey: 'id', allowEdit: false, allowCreate: false, allowDelete: false, baseFields: ['id']
      },
      fieldMetadata:
        [
          { name: 'journalDate', text: "Dato kladde", format: 'DateShort' },
          { name: 'journalVoucher', text: "Bilag", visible: false },
          { name: 'journalAccountType', text: "Kladdekontotype", visible: false },
          { name: 'journalAccountNum', text: "Kreditor", foreignKey: { navigations: [{ link: 'fk', foreignKey: { parentEntity: 'VendorView', parentColumn: 'num' } }] } },
          { name: 'journalTxt', text: "Tekst" },
          { name: 'journalExchRate', text: "Kurs", visible: false },
          { name: 'journalModified', text: "Ændret kladde", format: 'DateShort', visible: false },
          { name: 'journalPaymentSpec', text: "Ovf.spec. kladde", visible: false },
          { name: 'journalPaymentType', text: "Ovf.type" },
          { name: 'journalPaymentId', text: "Betal.Id" },
          { name: 'fromLedgerAccount', text: "Fra finanskonto", visible: false },
          { name: 'bankFromName', text: "Fra bankkontonavn", visible: false },
          { name: 'journalBankAccount', text: "Til bankkonto" },
          { name: 'toTownName', text: "By" },
          { name: 'toCountry', fieldType: 'country' },
          { name: 'journalAmountCur', text: "Beløb", format: 'Amount' },
          { name: 'journalCurrency', fieldType: 'currency' },
          { name: 'invoicePartialPayment', text: "Samlet", format: 'CheckBox'},
          { name: 'invoiceAmountCur', text: "Beløb faktura", format: 'Amount' },
          { name: 'invoiceCurrency', text: "Valuta faktura", fieldType: 'currency' },
          { name: 'invoiceDate', text: "Fakturadato", format: 'DateShort', visible: false },
          { name: 'invoiceDueDate', text: "Forfaldsdato", format: 'DateShort' },
          { name: 'invoiceId', text: "Faktura id', format: 'Number", visible: false },
          { name: 'invoiceNum', text: "Faktura" },
          { name: 'invoiceVoucher', text: "Fakturabilag", visible: false },
          { name: 'invoiceType', text: "Fakturatype", format: 'Number', visible: false },
          { name: 'invoiceApproved', text: "Godkendt", format: 'CheckBox', visible: false },
          { name: 'invoiceOpen', text: "Åben", format: 'CheckBox', visible: false },
          { name: 'invoiceCashDiscAmountCur', text: "Kasserabat", format: 'Amount0', visible: false},
          { name: 'invoiceCashDiscDate', text: "Dato kasserabat", format: 'DateShort', visible: false },
          { name: 'vendorId', text: "Kreditor id", visible: false },
          { name: 'vendorNum', text: "Kreditorkonto", visible: false },
          { name: 'toName', text: "Kreditornavn" },
          { name: 'toAddress1', text: "Addresse 1" },
          { name: 'toAddress2', text: "Addresse 2" },
          { name: 'toZipCity', text: "Postnr./By", visible: false },
          { name: 'toAttention', text: "Attention", visible: false },
          { name: 'toPhone', text: "Telefon", format: 'Phone', visible: false },
          { name: 'toEmail', text: "E-mail", format: 'Email', visible: false },
          { name: 'vendorActive', text: "Aktiv", format: 'CheckBox', visible: false },
          { name: 'vendorLatestInvoiceDate', text: "Seneste faktura", format: 'DateShort', visible: false  },
          { name: 'vendorLatestPaymentDate', text: "Seneste betaling", format: 'DateShort', visible: false },
          { name: 'vendorPaymentMode', text: "Betal.måde (kreditor)", visible: false },
          { name: 'vendorPaymentSpecVendor', text: "Betal.spec. (kreditor)", visible: false },
          { name: 'bankToAccountNum', text: "Bankkonto", width: '140px' },
          { name: 'bankToAccountOCR', text: "FIK konto"},
          { name: 'bankToSWIFTAccount', text: "SWIFT konto", width: '120px' },
          { name: 'bankToIBAN', text: "IBAN", width: '200px' },
          { name: 'bankToName', text: "Bank navn", visible: false },
          { name: 'bankToAddress1', text: "Bank adr. 1", visible: false },
          { name: 'bankToAddress2', text: "Bank adr. 2", visible: false },
          { name: 'bankToZipCity', text: "Bank postnr./by", visible: false },
          { name: 'bankToTownName', text: "Bank by" },
          { name: 'bankToAttention', text: "Bank attention", visible: false },
          { name: 'bankToCountry', text: "Bank land", fieldType: 'country'}, 
          { name: 'bankToPhone', text: "Bank telefon", format: 'Phone', visible: false }
        ],
      toolbarCommands: [uiCmdPaymentFileCreate],
      onCommandEvent: (e => this.onCommand(e))
    });
  }

  public onCommand(event: UiCommandEvent) {
    switch (event.commandId) {
      case uiCmdPaymentFileCreate.id:
        this.paymentFileCreateApi(null, event.appComponent); // event.rowsData?.map(r => r.id)
        break;
    }
  }

  private paymentFileCreateApi(rowIds: number[], appComponent: ICerViewComponent) {
    const ui = this.context.ui;
    ui.operationBegin('Henter betalingsfil');
    //var = new BankTransactionSourceBatchClient());
    var bankPaymentJournalClient: BankPaymentJournalClient = this.context.injector.get(BankPaymentJournalClient);
    bankPaymentJournalClient.paymentFileCreate(rowIds).subscribe({
      next: (file) => {
        const transCount =  file.headers['x-cerium-transactioncount'];        
        const errors =  file.headers['x-cerium-errors'];
        if (errors?.length > 0)
        {
          ui.operationEndError(null,errors);
        }
        else {
          ui.operationEnd();
        }
        ui.toast(transCount + ' bevægelser hentet');
        ui.downloadFile(file);
        appComponent.research();
      },
      error: (error) => {
        ui.operationEndError(error);
      }
    });
  }
}
